import { render, staticRenderFns } from "./FairNavigation.vue?vue&type=template&id=624e3fdf&scoped=true"
import script from "./FairNavigation.vue?vue&type=script&lang=js"
export * from "./FairNavigation.vue?vue&type=script&lang=js"
import style0 from "./FairNavigation.vue?vue&type=style&index=0&id=624e3fdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e3fdf",
  null
  
)

export default component.exports